export default __webpack_public_path__ + "static/media/talkia.a75ff568.PNG";